<template>
  <vs-popup class="view-customer-agreements" id="popup" title="CHANNEL PARTNER CUSTOMER AGREMENTS" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button @click.stop="onClickCreate" class="mb-2 float-right">Create an agreement</vs-button>
        </div>
      </div>
      <vs-table id="suppliers-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="customer_agreements"
        :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

        <template slot="thead">
          <vs-th>CHANNEL PARTNER AGREEMENT CODE</vs-th>
          <vs-th>AGREEMENT START DATE</vs-th>
          <vs-th>AGREEMENT END DATE</vs-th>
          <vs-th>PERCENTAGE (%)</vs-th>
          <vs-th>STATUS</vs-th>
          <vs-th>CREATED AT</vs-th>
          <vs-th>CREATED BY</vs-th>
          <vs-th width="15%">STATUS ACTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].code">
              {{ data[indextr].code }}
            </vs-td>
            <vs-td :data="data[indextr].start_date">
              {{ data[indextr].start_date }}
            </vs-td>
            <vs-td :data="data[indextr].end_date">
              {{ data[indextr].end_date }}
            </vs-td>
            <vs-td :data="data[indextr].percent">
              {{ data[indextr].percent }}
            </vs-td>
            <vs-td :data="data[indextr].is_approved">
              {{ data[indextr].status }}
            </vs-td>
            <vs-td>
              {{ __dateTimeFormatter(data[indextr].created_at) }}
            </vs-td>
            <vs-td :data="data[indextr].created_by">
              {{ data[indextr].created_by }}
            </vs-td>
            <vs-td>
              <div class="vx-row flex">
                <span class="flex" v-for="(status, status_index) in partner_customer_agreement_statuses" :key="status_index">
                  <vs-button 
                    size="small" 
                    @click.stop="onClickChangeStatus(data[indextr].id, status.name)" 
                    v-if="status.before_status.includes(data[indextr].status)" 
                    class="mr-2"
                    type="border"
                    :color="status.color">
                    {{ status.label }}
                  </vs-button>
                </span>
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20" :max-items="perPage"
        description-body="Rows per page" description-connector="of" description-title="Records" description
        :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
      </vs-pagination>
    </vx-card>
    <CreateChannelPartnerAgreementPopUp ref="createChannelPartnerAgreementPopUp"
      v-on:refreshData="fetchCustomerAgreements" />
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner');
const CurrencyRepository = RepositoryFactory.get('currency');
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
const CountryCodeRepository = RepositoryFactory.get('countryCode');
const UserRepository = RepositoryFactory.get('user');
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { defaultPagination, perPageList } from "@/constants/config";
import CreateChannelPartnerAgreementPopUp from '@/components/popups/channel-partners/CreateChannelPartnerAgreementPopUp.vue'
import { partner_customer_agreement_statuses } from '@/constants/statuses.js'

function initialState() {
  return {
    open: false,
    createStaffForm: {
      agreement: {
        date_introduced: '',
        start_date: '',
        end_date: '',
        percent: ''
      }
    },
    meta: {},
    page: 1,
    total: 0,
    meta: {},
    sort: '',
    perPage: defaultPagination,
    descriptionItems: perPageList,
    countryCodes: [],
    account_handlers: [],
    tenant_id: null,
    customer_id: null,
    customer_agreements: [],
    partner_customer_agreement_statuses: partner_customer_agreement_statuses
  }
}

export default {
  name: 'ViewChannelPartnerCustomerAgreementsPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
    flatPickr,
    CreateChannelPartnerAgreementPopUp
  },

  methods: {
    async openPopup(data) {
      try {
        Object.assign(this.$data, initialState())
        this.tenant_id = data.customer.id
        this.customer_id = data.id
        await this.fetchCustomerAgreements()
        this.open = true;
      } catch (error) {
        console.log("error", error)
      }
    },
    async loadCountryCodes() {
      const { data } = await CountryCodeRepository.get()
      this.countryCodes = data.data
    },
    async fetchCustomerAgreements() {
      const { data } = (await ChannelPartnerRepository.getCustomerAgreements(this.customer_id, 1, 150))
      this.customer_agreements = data.data
      this.meta = data.meta
    },
    onClickReset() {
      this.createStaffForm = {}
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleChangePage(page) {
      this.page = page;
      this.fetchCustomerAgreements()
    },
    async onClickCreate() {
      this.$refs.createChannelPartnerAgreementPopUp.openPopup(this.tenant_id, this.customer_id)
    },
    async onClickChangeStatus(id, status_name) {
      try {
        await ChannelPartnerRepository.changeAgreementStatus(id, status_name)
        await this.fetchCustomerAgreements()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  },
  watch: {
    page() {
      this.fetchCustomerAgreements()
    },
    perPage() {
      this.fetchCustomerAgreements()
    }
  }
}
</script>

<style scoped>
.view-customer-agreements>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 60% !important;
}
</style>
